"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorMessage = exports.ErrorsWrapper = exports.StyledPlainInput = exports.StyledTextArea = exports.StyledMaskedInput = exports.DataWrapper = exports.InputWrapper = exports.Wrapper = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _reactTextMask = _interopRequireDefault(require("react-text-mask"));

var _reactTextareaAutosize = _interopRequireDefault(require("react-textarea-autosize"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// External
var alignContent = function alignContent(props) {
  switch (props.aligninput) {
    case 'center':
      return (0, _styledComponents.css)(["align-content:center;text-align:center;justify-content:center;"]);

    case 'right':
      return (0, _styledComponents.css)(["align-content:flex-end;text-align:right;justify-content:flex-end;"]);

    default:
      return (0, _styledComponents.css)(["align-content:flex-start;text-align:left;justify-content:flex-start;"]);
  }
};

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Inputstyles__Wrapper",
  componentId: "sc-1bg2c7u-0"
})(["width:100%;", ";"], function (props) {
  return alignContent(props);
});

exports.Wrapper = Wrapper;

var InputWrapper = _styledComponents.default.div.withConfig({
  displayName: "Inputstyles__InputWrapper",
  componentId: "sc-1bg2c7u-1"
})(["border-bottom:", " solid ", ";display:inline-flex;margin-bottom:", ";overflow:hidden;width:", ";", ";", ";", ";", ";"], function (props) {
  return props.theme.thinLine;
}, function (props) {
  return props.theme.c_foreground_default;
}, function (props) {
  return props.theme.thickLine;
}, function (props) {
  return props.inputWidth === 'fitText' ? 'auto' : '100%';
}, function (props) {
  return props.inViewMode && (0, _styledComponents.css)(["border-bottom:1px solid transparent;"]);
}, function (props) {
  return props.disabled && (0, _styledComponents.css)(["border-bottom:", " dashed ", ";background-color:", ";"], props.theme.thinLine, props.theme.c_foreground_disabled, props.theme.c_background_disabled_veryLight);
}, function (props) {
  return props.focused && (0, _styledComponents.css)(["border-bottom:", " solid ", ";margin-bottom:", ";"], props.theme.thickLine, props.theme.c_foreground_primary, props.theme.thinLine);
}, function (props) {
  return props.hasErrors && (0, _styledComponents.css)(["border-bottom-color:", ";"], props.theme.c_foreground_danger);
});

exports.InputWrapper = InputWrapper;

var DataWrapper = _styledComponents.default.div.withConfig({
  displayName: "Inputstyles__DataWrapper",
  componentId: "sc-1bg2c7u-2"
})(["position:relative;width:", ";"], function (props) {
  return props.inputWidth === 'fitText' ? 'auto' : '100%';
});

exports.DataWrapper = DataWrapper;
var styledInput = (0, _styledComponents.css)(["align-items:center;border:none;box-sizing:border-box;color:", ";display:block;font-family:", ";font-size:1rem;line-height:1.1875rem;outline:none;padding:", ";position:absolute;transform:", ";white-space:nowrap;width:100%;", ";"], function (props) {
  return props.theme.c_foreground_default;
}, function (props) {
  return props.theme.primaryFont;
}, function (props) {
  return props.zeropadding === 'true' ? "".concat(props.theme.standardPadding, " ").concat(props.theme.standardPadding, " ").concat(props.theme.standardPadding, " 0") : props.theme.standardPadding;
}, function (props) {
  return props.inviewmode === 'true' ? 'translate(0, -20000px)' : 'translate(0,-100%)';
}, function (props) {
  return alignContent(props);
});
var StyledMaskedInput = (0, _styledComponents.default)(_reactTextMask.default).withConfig({
  displayName: "Inputstyles__StyledMaskedInput",
  componentId: "sc-1bg2c7u-3"
})(["", ";"], styledInput);
exports.StyledMaskedInput = StyledMaskedInput;
var StyledTextArea = (0, _styledComponents.default)(_reactTextareaAutosize.default).withConfig({
  displayName: "Inputstyles__StyledTextArea",
  componentId: "sc-1bg2c7u-4"
})(["", ";white-space:normal;resize:none;"], styledInput);
exports.StyledTextArea = StyledTextArea;

var StyledPlainInput = _styledComponents.default.input.withConfig({
  displayName: "Inputstyles__StyledPlainInput",
  componentId: "sc-1bg2c7u-5"
})(["", ";"], styledInput);

exports.StyledPlainInput = StyledPlainInput;

var ErrorsWrapper = _styledComponents.default.div.withConfig({
  displayName: "Inputstyles__ErrorsWrapper",
  componentId: "sc-1bg2c7u-6"
})(["margin-bottom:", ";min-height:2rem;", ";"], function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return alignContent(props);
});

exports.ErrorsWrapper = ErrorsWrapper;

var ErrorMessage = _styledComponents.default.div.withConfig({
  displayName: "Inputstyles__ErrorMessage",
  componentId: "sc-1bg2c7u-7"
})(["color:", ";margin:0;"], function (props) {
  return props.theme.c_foreground_danger;
});

exports.ErrorMessage = ErrorMessage;